
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/filestage-pricing",
      function () {
        return require("private-next-pages/comparisons/filestage-pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/filestage-pricing"])
      });
    }
  